/**
 * Marathi for the `booking` namespace (BP-19.T2).
 *
 * **Machine draft, not reviewed** — see `strings.hi.ts` for why this namespace is
 * translated in full.
 */

export const bookingStringsMr = {
  landing: {
    title: 'अपॉइंटमेंट बुक करा',
    lead: 'तुमच्या सेवा निवडा, वेळ ठरवा — खुर्ची तुमच्यासाठी राखून ठेवू.',
    start: 'आता बुक करा',
    mine: 'माझ्या बुकिंग',
  },
  steps: {
    services: 'सेवा',
    technician: 'टेक्निशियन',
    slot: 'वेळ',
    verify: 'तुमचा नंबर',
    confirm: 'खात्री',
  },
  services: {
    title: 'तुम्हाला काय करून घ्यायचे आहे?',
    none: 'सध्या ऑनलाइन कोणतीही सेवा बुक करता येत नाही',
    addons: 'जादा सेवा',
    duration: '{{minutes}} मिनिटे',
    running: '{{minutes}} मिनिटे · ₹{{amount}}',
    next: 'टेक्निशियन निवडा',
    pickOne: 'किमान एक सेवा निवडा',
  },
  technician: {
    title: 'कोणाकडून करून घ्यायचे?',
    any: 'जो कोणी उपलब्ध असेल',
    anyHint: 'सर्वात आधी मोकळी होणारी खुर्ची',
    next: 'वेळ निवडा',
    none: 'सध्या कोणीही ऑनलाइन बुकिंग घेत नाही',
  },
  slot: {
    title: 'कोणती वेळ चालेल?',
    none: 'त्या दिवशी काहीही मोकळे नाही',
    suggestion: 'पुढचा मोकळा दिवस {{date}} आहे',
    next: 'पुढे चला',
  },
  verify: {
    title: 'तुमचा मोबाइल नंबर',
    phone: 'मोबाइल नंबर',
    phoneHint: 'आम्ही WhatsApp वर एकदाच वापरायचा कोड पाठवतो.',
    phoneInvalid: 'हा भारतीय मोबाइल नंबर वाटत नाही.',
    send: 'कोड पाठवा',
    resend: 'पुन्हा पाठवा',
    resendIn: 'तुम्ही {{seconds}} सेकंदांनी पुन्हा मागू शकता',
    code: 'एकदाच वापरायचा कोड',
    verify: 'पडताळा',
    consent: 'मला WhatsApp वर अपॉइंटमेंटची आठवण करून द्या',
    consentHint: 'तुम्ही हे कधीही बंद करू शकता.',
    notice: 'आम्ही तुमच्या माहितीचे काय करतो',
    invalid: 'हा कोड जुळला नाही. पुन्हा प्रयत्न करा.',
    exhausted: 'खूप वेळा प्रयत्न झाले. नवा कोड मागा.',
  },
  confirm: {
    title: 'तुमच्या बुकिंगची खात्री करा',
    summary: 'तुमचे अपॉइंटमेंट',
    total: 'एकूण',
    book: 'खात्री करा',
    taken: 'ही वेळ आत्ताच गेली. कृपया दुसरी निवडा.',
    policy:
      'सुरू होण्याच्या {{hours}} तास आधीपर्यंत तुम्ही ही बुकिंग ऑनलाइन बदलू किंवा रद्द करू शकता. त्यानंतर सलूनला फोन करा.',
  },
  detail: {
    title: 'बुकिंग {{ref}}',
    when: 'कधी',
    status: 'स्थिती',
    reschedule: 'वेळ बदला',
    cancel: 'ही बुकिंग रद्द करा',
    cancelTitle: 'बुकिंग {{ref}} रद्द करायची?',
    cancelReason: 'कारण सांगा (ऐच्छिक)',
    cancelConfirm: 'हो, रद्द करा',
    cancelKeep: 'राहू द्या',
    locked: 'ही बुकिंग आता ऑनलाइन बदलता येणार नाही. कृपया सलूनला फोन करा.',
    pickNew: 'नवी वेळ निवडा',
    keep: 'सध्याची वेळ ठेवा',
    moved: 'तुमच्या बुकिंगची वेळ बदलली आहे.',
    cancelled: 'तुमची बुकिंग रद्द केली आहे.',
  },
  waitlist: {
    offer: 'ती वेळ घेतली गेली आहे. रिकामी झाल्यास तुम्हाला कळवू का?',
    join: 'रिकामी झाल्यास कळवा',
    joined: 'रिकामी होताच आम्ही तुम्हाला संदेश पाठवू.',
    failed: 'आत्ता तुम्हाला जोडता आले नाही. कृपया पुन्हा प्रयत्न करा.',
  },
  mine: {
    title: 'माझ्या बुकिंग',
    none: 'तुमची कोणतीही येणारी बुकिंग नाही',
    open: 'उघडा',
  },
} as const;
